import { ViewUser } from "../../services/authorization/Permissions";
import { NameEntityResponse } from "../../api-models/response/NameEntityResponse";
import { JobResponse } from "../../api-models/response/job/JobResponse";
import { dateService } from "../date-service/DateService";
import { permissionsService } from "../authorization/UserPermissionsService";
import { translationService } from "../translation/TranslationService";
import { RowItemData } from "../../components/datatable/interfaces";
import { JobStatus, JobType, JobPriority } from "../../generated/Jobs";

export class Job implements RowItemData {
  id: number;
  private name: string;
  private project: NameEntityResponse;
  private status: number;
  private type: number;
  private priority: number;
  private assignedUser: NameEntityResponse | null;
  private deadline: Date | null;
  private createdBy: NameEntityResponse;
  private modified?: Date | null;

  constructor(jobResponse: JobResponse) {
    this.id = jobResponse.id;
    this.name = jobResponse.name;
    this.project = jobResponse.project;
    this.status = jobResponse.status;
    this.type = jobResponse.type;
    this.priority = jobResponse.priority;
    this.assignedUser = jobResponse.assignedUser;
    this.deadline = jobResponse.deadline;
    this.createdBy = jobResponse.createdBy;
    this.modified = jobResponse.modified;
  }

  get displayValues() {
    return {
      name: { toDisplay: this.name, id: this.id, path: this.getPath() },
      status: { toDisplay: this.getDisplayStatus() },
      type: { toDisplay: this.getDisplayType() },
      priority: { toDisplay: this.getDisplayPriority() },
      deadline: { toDisplay: this.getDisplayDeadline() },
      assignedUser: {
        toDisplay: this.getAssignedUser(),
        id: this.getAssignedUserId(),
        path: this.getPathToAssignedUser(),
      },
      project: { toDisplay: this.getProjectName() },
      createdBy: {
        toDisplay: this.getCreatedByUserName(),
        id: this.getCreatedByUserId(),
        path: this.getPathToCreatedBy(),
      },
      modified: { toDisplay: this.getDisplayModified() },
    };
  }

  private getPath() {
    return "/jobs/:id";
  }
  private getDisplayStatus(): any {
    return translationService.translate(`general.jobs.status.${JobStatus[this.status]}`);
  }
  private getDisplayType(): any {
    return translationService.translate(`general.jobs.type.${JobType[this.type]}`);
  }
  private getCreatedByUserName(): string | null {
    return this.createdBy && this.createdBy.name;
  }
  private getProjectName(): string {
    return this.project && this.project.name;
  }
  private getAssignedUserId(): number | undefined {
    return this.assignedUser?.id;
  }
  private getAssignedUser(): any {
    return this.assignedUser && this.assignedUser.name;
  }
  private getDisplayDeadline(): string | null {
    return this.deadline ? dateService.formatDate(this.deadline) : null;
  }
  private getDisplayPriority(): string {
    return translationService.translate(`general.jobs.priority.${JobPriority[this.priority]}`);
  }
  private getDisplayModified(): string | null {
    return this.modified ? dateService.formatDate(this.modified) : null;
  }
  private getPathToCreatedBy(): string | undefined {
    const userHasPermission = permissionsService.userHasPermissionTo(ViewUser);
    return userHasPermission && !this.createdBy.isDeleted ? "/users/:id" : undefined;
  }
  private getPathToAssignedUser(): string | undefined {
    const userHasPermission = permissionsService.userHasPermissionTo(ViewUser);
    return userHasPermission && !this.assignedUser?.isDeleted && this.assignedUser?.id
      ? "/users/:id"
      : undefined;
  }
  private getCreatedByUserId(): any {
    return this.createdBy.id;
  }
}
